var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Input } from '@angular/core';
import { Comp } from '../../models/component/component';
import { BaseComponent } from './base.component';
// @Component({
// 	moduleId: module.id.toString(),
// 	template: '',
// 	styles: []
// })
var ContentBaseComponent = /** @class */ (function (_super) {
    __extends(ContentBaseComponent, _super);
    function ContentBaseComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.mode = '';
        _this.rec = {};
        _this.cols = [];
        _this.events = {};
        return _this;
    }
    ContentBaseComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.refSubscription = this.action.refObservable.subscribe(function (targets) {
            if (_this.componentName) {
                for (var _i = 0, targets_1 = targets; _i < targets_1.length; _i++) {
                    var target = targets_1[_i];
                    for (var _a = 0, _b = target.targets; _a < _b.length; _a++) {
                        var tar = _b[_a];
                        var re = new RegExp('^' + tar + '$');
                        if (_this.componentName.match(re)) {
                            _this.rec = target.rec || {};
                            _this.onSubscribe(_this.rec);
                            break;
                        }
                    }
                }
            }
            _this.onRefSubscribe();
        });
        this.modeSubscription = this.action.modeObservable.subscribe(function (mode) {
            _this.mode = mode;
            _this.onModeSubscribe(_this.mode);
        });
        this.eventSubscription = this.action.eventObservable.subscribe(function (event) {
            _this.onEventSubscribe(event);
        });
        this.changeSubscription = this.action.changeObservable.subscribe(function (compRec) {
            _this.onChangeSubscribe(compRec);
        });
        this.setUnsubscribe();
    };
    ContentBaseComponent.prototype.onConstruct = function () {
    };
    ContentBaseComponent.prototype.onInit = function (meta) {
        if (meta.components) {
            this.setEvents();
            this.changeCompData(meta.components);
        }
        if (this.component && this.component.model) {
            this.cols = [];
            if (meta.models && meta.models[this.component.model] && meta.models[this.component.model].items) {
                this.cols = $.extend(true, [], meta.models[this.component.model].items);
            }
        }
        this.rec = {};
    };
    // Set unsubscribe if the component does not need subscribe.
    ContentBaseComponent.prototype.setUnsubscribe = function () {
        // this.eventSubscription.unsubscribe();
        // this.refSubscription.unsubscribe();
        // this.modeSubscription.unsubscribe();
        // this.changeSubscription.unsubscribe();
    };
    ContentBaseComponent.prototype.onModeSubscribe = function (mode) {
    };
    ContentBaseComponent.prototype.onSubscribe = function (data) {
    };
    ContentBaseComponent.prototype.onRefSubscribe = function () {
    };
    ContentBaseComponent.prototype.onEventSubscribe = function (event) {
    };
    ContentBaseComponent.prototype.onChangeSubscribe = function (compRec) {
    };
    ContentBaseComponent.prototype.setCompData = function (name, component) {
        this.componentName = name;
        this.component = component;
    };
    ContentBaseComponent.prototype.changeCompData = function (components) {
        for (var _i = 0, components_1 = components; _i < components_1.length; _i++) {
            var c = components_1[_i];
            if ((this.component && c.name === this.component.name) || c.name === this.componentName) {
                this.setChangeCompData(c);
            }
            if (c.components) {
                this.changeCompData(c.components);
            }
        }
    };
    ContentBaseComponent.prototype.setChangeCompData = function (component) {
    };
    ContentBaseComponent.prototype.setEvents = function () {
        var events = (this.component && this.component.params && this.component.params.events ? this.component.params.events : {});
        for (var key in this.events) {
            if (typeof events[key] !== 'undefined') {
                this.events[key] = events[key];
            }
        }
    };
    ContentBaseComponent.prototype.trackByCol = function (index, col) {
        return JSON.stringify({ label: col.label, key: col.key });
    };
    ContentBaseComponent.prototype.trackByOption = function (index, option) {
        return option.code;
    };
    ContentBaseComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.eventSubscription.unsubscribe();
        this.refSubscription.unsubscribe();
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    ContentBaseComponent.propDecorators = {
        componentName: [{ type: Input }],
        component: [{ type: Input }]
    };
    return ContentBaseComponent;
}(BaseComponent));
export { ContentBaseComponent };
//# sourceMappingURL=contentbase.component.js.map